<div class="dashboard">
   <app-selected-dealer-hero [eyebrow]="greeting()" [showDate]="true"
                             emptyEyebrow="{{ greeting() }}"
                             emptyTitle="Welcome to Advantage 4 Dealers"
                             [emptyMessage]="null" />

   <div class="dashboard-body">

      <!-- ============================== main tiles ============================== -->
      <div class="tile-groups">
         @for (group of tileGroups(); track group.title) {
            <section class="tile-group">
               <h2 class="group-title">{{ group.title }}</h2>
               <div class="tiles">
                  @for (tile of group.tiles; track tile.title) {
                     @if (tile.routerLink) {
                        <a class="tile" [routerLink]="tile.routerLink">
                           <span class="icon"><i class="fa-solid {{ tile.icon }}" aria-hidden="true"></i></span>
                           <span class="text">
                              <span class="title">{{ tile.title }}</span>
                              <span class="description">{{ tile.description }}</span>
                           </span>
                           <i class="fa-solid fa-chevron-right go" aria-hidden="true"></i>
                        </a>
                     } @else {
                        <a class="tile" role="button" tabindex="0" (click)="open(tile)" (keydown.enter)="open(tile)">
                           <span class="icon"><i class="fa-solid {{ tile.icon }}" aria-hidden="true"></i></span>
                           <span class="text">
                              <span class="title">{{ tile.title }}</span>
                              <span class="description">{{ tile.description }}</span>
                           </span>
                           <i class="fa-solid {{ tile.externalUri ? 'fa-arrow-up-right-from-square' : 'fa-chevron-right' }} go" aria-hidden="true"></i>
                        </a>
                     }
                  }
               </div>
            </section>
         }

         <!-- quick links -->
         @if (quickLinks().length) {
            <section class="tile-group">
               <h2 class="group-title">Quick links</h2>
               <div class="quick-links">
                  @for (link of quickLinks(); track link.title) {
                     @if (link.routerLink) {
                        <a class="quick-link" [routerLink]="link.routerLink">
                           <i class="fa-solid {{ link.icon }}" aria-hidden="true"></i>{{ link.title }}
                        </a>
                     } @else {
                        <a class="quick-link" role="button" tabindex="0" (click)="open(link)" (keydown.enter)="open(link)">
                           <i class="fa-solid {{ link.icon }}" aria-hidden="true"></i>{{ link.title }}
                        </a>
                     }
                  }
               </div>
            </section>
         }
      </div>

      <!-- ============================== notifications ============================== -->
      @if (selectedDealer()) {
         <aside class="notifications">
            <div class="panel">
               <div class="panel-header">
                  <h2 class="group-title">
                     Notifications
                     @if (notificationCount()) {
                        <span class="badge rounded-pill">{{ notificationCount() > 5 ? '5+' : notificationCount() }}</span>
                     }
                  </h2>
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="seeAllNotifications()">See all</button>
               </div>

               @for (notification of notifications(); track notification.id) {
                  <div class="notification {{ notification.levelClass }}">
                     <div class="message" [innerHTML]="notification.messageMarkup"></div>
                     <div class="when">{{ notification.created }}</div>
                  </div>
               } @empty {
                  <p class="empty">
                     <i class="fa-regular fa-bell-slash me-1" aria-hidden="true"></i>
                     You're all caught up. Nothing needs your attention right now.
                  </p>
               }
            </div>
         </aside>
      }

   </div>

</div>
